export function shortid() {
  return Math.random().toString(32).slice(2, -1);
}
